<script>
    import {
        CardLayout,
        SvelteTable,
    } from "../../../Components/Common/index.svelte";

    import {
        getAmountInCurrency,
        getText,
    } from "../../../Utils/utilFunctions.svelte";

    export let billingItems = [];

    const columns = [
        {
            key: "title",
            title: "Title",
            headerClass: "text-left px-6 font-bold",
            class: "text-left px-6 w-1/2",
            value: (v) => getText(v.title),
            renderValue: (v) => (v.isLast ? "" : getText(v.title)),
        },
        {
            key: "subTotal",
            title: "Subtotal",
            headerClass: "text-left px-6 font-bold",
            class: "text-left px-6 w-1/4",
            renderValue: (v) => (v.isLast ? "" : getAmountInCurrency(v.rate)),
        },
        {
            key: "gst",
            title: "GST",
            headerClass: "text-left px-6 font-bold",
            class: "text-left px-6 w-1/4",
            value: (v) => getText(v.title),
            renderValue: (v) =>
                v.isLast
                    ? _renderLastDescription()
                    : getAmountInCurrency(v.tax),
        },
        {
            key: "total",
            title: "Total",
            headerClass: "text-left px-6 font-bold rounded-tr-xl",
            class: "text-left px-6",
            value: (v) => getAmountInCurrency(v.totalAmount),
        },
    ];

    const handleClickCell = (
        { target: { className, classList } },
        rowData,
        key,
    ) => {};

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    // HELPER FUNCTIONS
    const _renderLastDescription = () => {
        return `<div class="flex flex-1 w-full justify-end items-center">Total:</div>`;
    };
</script>

<CardLayout title="Items">
    <div class={`flex flex-1 ${billingItems.length ? "" : "pb-4"}`}>
        <SvelteTable
            {columns}
            rows={billingItems}
            clickCellFunc={({ detail: { event, row, key } }) => {
                handleClickCell(event, row, key);
            }}
            clickColFunc={({ detail: { event, row, key } }) => {
                handleClickCol(event, row, key);
            }}
        />
    </div>
</CardLayout>
